export default __webpack_public_path__ + "static/media/myanmar2015B.9df6cd5b.jpg";